<template>
  <el-row>
    <el-col :sm="19">
      <div class="my-ads">
        <div class="about d-flex">
          <div>
            <el-button icon="icon-eye">
              {{ viewersCount ? viewersCount : 0 }}
            </el-button>
            <el-button icon="icon-massage">
              {{ messagesCount ? messagesCount : 0 }}
            </el-button>
            <!--<el-button icon="icon-phone-receiver">{{about.calls}}</el-button>-->
            <el-button icon="icon-heart">
              {{ favoritesCount ? favoritesCount : 0 }}
            </el-button>
          </div>
          <div
            v-if="!isInactive"
            class="actions"
          >
            <div
              v-if="isMobile"
              class="status-button"
            >
              <el-switch
                v-model="active"
                :active-value="1"
                :inactive-value="0"
              />
            </div>
          </div>
        </div>
        <div
          v-if="!isInactive"
          class="actions"
        >
          <div v-if="!isMobile">
            <span>{{ $t('account-settings.my-ads.buttons.feature.text') }}</span>
            <el-button
              class="feature"
              circle
              icon="icon-favorites"
              @click="$emit('onFeature')"
            />
            <span> {{ $t('account-settings.my-ads.buttons.edit.text') }}</span>
            <el-button
              class="edit"
              circle
              icon="icon-pencil-edit-button"
              @click="$emit('onEdit')"
            />
            <span>{{ $t('account-settings.my-ads.buttons.delete.text') }}</span>
            <el-button
              class="delete"
              circle
              icon="el-icon-close"
              @click="$emit('onDelete')"
            />
            <span>{{ $t('account-settings.my-ads.buttons.active.text') }}</span>
            <el-switch
              v-model="active"
              :active-value="1"
              :inactive-value="0"
            />
          </div>
          <div class="feature-button">
            <el-button
              v-if="isMobile"
              class="feature"
              icon="icon-favorites"
              @click="$emit('onFeature')"
            >
              {{ $t('account-settings.my-ads.buttons-mobile.feature.text') }}
            </el-button>
          </div>
          <div
            v-if="isMobile"
            class="edit-button"
          >
            <el-button
              class="edit"
              circle
              icon="icon-pencil-edit-button"
              @click="$emit('onEdit')"
            />
          </div>
          <div
            v-if="isMobile"
            class="delete-button"
          >
            <div
              class="el-button delete el-button--default is-circle d-flex"
              @click="$emit('onDelete')"
            >
              <i class="el-icon-close" />
            </div>
          </div>
        </div>
        <div
          v-if="isInactive"
          class="actions inactive"
        >
          <span v-if="!isMobile">{{ $t('account-settings.my-ads.delete-from-list') }}</span>
          <el-button
            v-if="!isMobile"
            circle
            icon="el-icon-close"
            @click="$emit('onDelete')"
          />
          <el-switch
            v-model="active"
            class="refresh"
            :active-value="1"
            :inactive-value="0"
          />
          <!--<el-button class="primary" icon="icon-refresh" circle @click="active = 1"></el-button>-->
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    // eslint-disable-next-line vue/require-prop-types
    props: [ 'isInactive', 'favoritesCount', 'messagesCount', 'viewersCount' ],
    data() {
      return {
        about: {
          viewers: 10,
          messages: 10,
          calls: 10,
          favorites: 10,
        },
        active: false,
      };
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
      }),
    },
    watch: {
      isInactive: {
        immediate: true,
        handler(val) {
          this.active = !val ? 1 : 0;
        },
      },
      active(val) {
        // eslint-disable-next-line no-underscore-dangle
        if (this._isMounted) {
          this.$emit('activeChange', val);
        }
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Ads/MyAds.vue